export default "__VITE_ASSET__BwcbmQK$__"